import tickIcon from "../../assets/icons/tick-thick.svg";

const FlightBriefPassengers = ({ briefData }) => {
    const getPlaceholders = () => {
        const placeholders = [];

        for (let i = 0; i < briefData.numberPax; i++) {
            placeholders.push(`Passenger ${i + 1}`);
        }

        return placeholders;
    };

    return (
        <div className="flight-brief__content-grid flight-brief__content-grid--people">
            {briefData.passengerDetails.length > 0 ? (
                <>
                    {briefData.passengerDetails.map((item, itemId) => {
                        return (
                            <div key={itemId}>
                                <div className="flight-brief__dark-title">{item.name}</div>
                                <div className="flight-brief__body-text">
                                    <p>
                                        <img src={tickIcon} alt="" /> Details provided
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </>
            ) : (
                getPlaceholders().map((placeholder, i) => (
                    <div className="flight-brief__dark-title" key={i}>
                        {placeholder}
                    </div>
                ))
            )}
        </div>
    );
};

export default FlightBriefPassengers;
